import React, { Component } from 'react'
import ProgressBar from './ProgressBar'
import { Modal } from 'components/basic'
import { notify } from 'helpers'
import { default as axios } from 'axios'
import { connect } from 'react-redux'
import FileSaver from 'file-saver'
import { Base64 } from 'js-base64'

class FileUpload extends Component {
  constructor (props) {
    super(props)
    this.state = {
      progress: 0,
      status: 'Waiting for file',
      file: null,
      filename: null,
      url: props.url
    }
  }

  componentDidMount () {
    this.setState({url: this.props.url})
  }

  componentWillReceiveProps (props) {
    this.setState({url: props.url})
  }

  selectFile () {
    document.querySelector('#file-picker').click()
  }

  processFile () {
    var file = document.querySelector('input[type=file]').files[0]
    this.setState({filename: file.name, file: file})
  }

  async upload () {
    notify.success('Please wait...')
    var config = {
      onUploadProgress: function (progressEvent) {
        this.setState({progress: Math.round((progressEvent.loaded * 100) / progressEvent.total)})
      }.bind(this)
    }
    var [err] = await axios.request({
      url: this.state.url,
      data: this.state.file,
      method: 'post',
      headers: {
        'Cache-Control': 'no-cache',
        'Content-Type': 'text/csv',
        'Authorization': 'Basic ' + Base64.encode(this.props.auth.username + ':' + this.props.auth.password)
      },
      ...config
    }).then(res => {
      let blob = new window.Blob([res.data], { type: 'text/csv' })
      FileSaver.saveAs(blob, 'completed_user_import.csv')
      this.setState({
        status: 'File uploaded',
        file: null,
        filename: null,
        progress: 0
      })
      this.props.reload()
      notify.alert('', 'File uploaded successfully.', 'success')
    }).catch(err => [err])
    if (err) return notify.alert('', err.message, 'error')
  }

  render () {
    return (
      <span>
        {this.props.displayInline &&
          <span>
            <small>{this.state.filename || this.state.status}</small>
            <ProgressBar percentage={this.state.progress} />
            <span>
              <span className='pull-left'>
                <button className='btn btn-primary btn-sm' onClick={() => this.selectFile()}>Select File</button>
                <input className='hidden' id='file-picker' type='file' onChange={() => this.processFile()} />
              </span>
              <span className='pull-right'>
                <button className={this.state.file ? 'btn btn-sm' : ' hidden'} onClick={() => this.resetUpload()}>Cancel</button>
                <button className={this.state.file ? 'btn btn-primary btn-sm' : ' hidden'} onClick={() => this.upload()}>Upload</button>
              </span>
            </span>
          </span>
        }
        {!this.props.displayInline &&
          <Modal
            close={() => this.resetUpload()}
            isOpen={this.props.modal}
            title={this.state.filename || 'Pick a file'}
            buttons={[
              { text: 'Select file', event: () => this.selectFile(), hidden: this.state.file },
              { text: 'Cancel', hidden: !this.state.file, event: () => this.resetUpload() },
              { text: 'Upload', hidden: !this.state.file, event: () => this.upload() }
            ]}>
            <small>{this.state.status}</small>
            <ProgressBar percentage={this.state.progress} />
            <input id='file-picker' type='file' className='hidden' onChange={() => this.processFile()} />
          </Modal>
        }
      </span>
    )
  }
}
//eslint-disable-next-line
FileUpload = connect(state => state.siteReducer)(FileUpload)
export default FileUpload



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/components/core/FileUpload.js